var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvertedcommas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.82609 12.0005V7.61788C7.82609 5.60049 8.26087 3.93092 9.13043 2.60918C10.0348 1.28744 11.3391 0.417878 13.0435 0.000488281V1.82657C12 2.10483 11.2522 2.62657 10.8 3.39179C10.3478 4.12223 10.087 5.07875 10.0174 6.26136H12V12.0005H7.82609ZM0 12.0005V7.61788C0 5.60049 0.434782 3.93092 1.30435 2.60918C2.2087 1.28744 3.51304 0.417878 5.21739 0.000488281V1.82657C4.17391 2.10483 3.42609 2.62657 2.97391 3.39179C2.52174 4.12223 2.26087 5.07875 2.1913 6.26136H4.17391V12.0005H0Z",
    fill: "#93C5FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvertedcommas);
export default __webpack_public_path__ + "static/media/invertedcommas.606615a25246efa445b61f383f11e4f4.svg";
export { ForwardRef as ReactComponent };